class IntroSlider {
    heading: any;
    subheading: any;
    headingWrapper: any;
    subheadingWrapper: any;
    autoplay: number;
    dots: any;
    headingId: number;
    subheadingId: number;
    speed: number;
    dotsArray: any;
    interval: any;
    intro: any;

    constructor() {
        this.intro = document.querySelector('#intro');

        if (this.intro) {
            this.heading = document.querySelectorAll('.intro__inner--heading');
            if (this.heading.length > 1) {

                this.config();

                //dots array
                this.dotsArray = [].slice.call(this.dots);

                this.setHeight(this.heading, this.headingWrapper);
                this.setHeight(this.subheading, this.subheadingWrapper);

                //assign unique ids to dots
                this.uniqueIds(this.dotsArray);

                //first dot active on load
                this.dots[0].classList.add('active');

                //change slide
                this.dotsArray.forEach((dot: any) => {
                    dot.addEventListener('click', () => {
                        let id = Number(dot.getAttribute('data-id'));

                        //reset interval after choosing slide
                        clearInterval(this.interval);
                        this.playSlider(id+1);

                        if (dot.classList.contains('active')) {
                            return false;
                        }
                        
                        this.dotsArray.forEach((active: any) => active.classList.remove('active'));
                        dot.classList.add('active');

                        this.toggle(id);

                    })
                });
                this.playSlider(1);
            } else {
                //fallback when there is no slider - only 1 item
                document.querySelector('.intro__inner--heading').classList.add('relative');
                document.querySelector('.intro__inner--subheading').classList.add('relative');
                document.querySelector('.intro__dots').classList.add('none');
            }
        }
    }

    public config() {
        this.subheading = document.querySelectorAll('.intro__inner--subheading');
        this.dots = document.querySelectorAll('.intro__dot');

        this.headingWrapper = document.querySelector('.intro__heading');
        this.subheadingWrapper = document.querySelector('.intro__subheading');

        this.autoplay = 5000;
        this.speed = 1;
    }

    public uniqueIds(array: any) {
        array.forEach((element: any, index: number) => element.setAttribute('data-id', index));
    }

    public setHeight(element: any, parent: any) {
        //make nodelist an array
        let array = [].slice.call(element);
        let highest = array[0];

        this.uniqueIds(array);

        //find and assign the highest
        array.map((item: any) => {
            if (item.offsetHeight >= highest.offsetHeight) {
                highest = item;
            }
        });

        let height = highest.offsetHeight;
        parent.style.height = `${height}px`;

        //set height again on resize
        window.addEventListener('resize', () => {
            array.map((item: any) => {
                if (item.offsetHeight >= highest.offsetHeight) {
                    highest = item;
                }
            });
            height = highest.offsetHeight;
            parent.style.height = `${height}px`;
        });
    }

    public toggle(identificator:number) {
        this.hide(this.heading, 0);
        this.hide(this.subheading, 0);

        this.show(this.heading[identificator], 0);
        this.show(this.subheading[identificator], 0);
    }


    public playSlider(autoId: number) {
        this.interval = setInterval(() => {

            if (autoId === this.dotsArray.length) {
                autoId = 0;
            }

            this.toggle(autoId);

            this.dotsArray.forEach((active: any) => active.classList.remove('active'));

            let dot = document.querySelector(`.intro__dots [data-id="${autoId}"]`);
            dot.classList.add('active');

            autoId ++;

        }, this.autoplay);
    }

    public show(element: any, delay: number) {
        const tl = new TimelineMax();
        tl.to(element, this.speed, {
            y: "0px",
            autoAlpha: 1,
            ease: Power3.easeIn
        }, delay)
    };

    public hide(element: any, delay: number) {
        const tl = new TimelineMax();
        tl
            .to(element, this.speed, {
                y: "15px",
                autoAlpha: 0,
                ease: Power3.easeOut
            }, delay)
    };
}